import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ReferralPortal from './Referral/ReferralPortal';
import TopBar from './Referral/TopBar';

import './App.css';

function App() {
  return (
    <>
      <TopBar />
      <Routes>
        <Route path="/" element={<ReferralPortal />} />
        <Route path="/:guid" element={<ReferralPortal />} />
      </Routes>
    </>
  );
}

export default App;
